// src/shared/ui/StatTile.jsx
//
// Small KPI tile for a summary row atop an admin/list page — first built
// for accounts/pages/AccountsPage.jsx (a bare table read as too plain next
// to GoLive/Connections' cards), then reused by ProjectsPage and
// ConnectorsPage for the same reason, so promoted here instead of being
// copy-pasted a third time.
//
// Usage:
//   <StatTile icon={Building2} label="Total Accounts" value={12} />
//   <StatTile icon={FolderGit2} label="Total Projects" value={4} hint="Jade Global" />

import PropTypes from "prop-types";

export default function StatTile({ icon: Icon, label, value, hint, tone = "brand" }) {
  const TONE = {
    brand: { bg: "var(--jade-blue-50)", fg: "var(--jade-blue-700)" },
    success: { bg: "var(--jade-success-100)", fg: "var(--jade-success-700)" },
    danger: { bg: "#fee2e2", fg: "var(--jade-danger-700)" },
  };
  const { bg, fg } = TONE[tone] || TONE.brand;

  return (
    <div className="flex items-center gap-3.5 bg-white border border-line rounded-xl p-4 shadow-[var(--jade-sh-1)]">
      <div
        className="flex items-center justify-center rounded-xl shrink-0"
        style={{ width: 42, height: 42, background: bg, color: fg }}
      >
        <Icon size={20} />
      </div>
      <div className="min-w-0">
        <p className="text-2xl font-bold text-ink leading-tight" style={{ fontFamily: "var(--jade-font-display)" }}>
          {value}
        </p>
        <p className="text-xs text-muted mt-0.5 truncate">{label}</p>
        {hint && <p className="text-[11px] text-muted mt-0.5 truncate">{hint}</p>}
      </div>
    </div>
  );
}

StatTile.propTypes = {
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
  hint: PropTypes.node,
  tone: PropTypes.oneOf(["brand", "success", "danger"]),
};
